export enum MODE {
  KIOSK,
  DESKTOP,
  MOBILE,
}
